import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import {
  columnDataset, columnProject, columnName,
} from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import ArchivalDialogContent from '@/components/dialogs/ArchivalDialogContent';
import { hideArchiveRequest, archiveRequests } from '../actions';
import RequestsTableColumns from '../components/RequestsTableColumns';
import RequestsTableRows from './RequestsTableRows';

const RequestArchivalDialog = ({
  archiveData,
  hide,
  results,
  theme,
}) => (
  <ArchivalDialogContent
    className="aridhia-request-archival-dialog"
    entity="request"
    entities="requests"
    hide={hide}
    icon="key"
    items={results}
    onArchive={archiveData}
    theme={theme}
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-requests-table">
        <Table.Header fullWidth>
          <RequestsTableColumns items={results} columns={[columnName, columnProject, columnDataset]} />
        </Table.Header>
        <Table.Body>
          <RequestsTableRows items={results} columns={[columnName, columnProject, columnDataset]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ArchivalDialogContent>
);

const mapStateToProps = ({
  requests: { requests: { deletion: { results } } },
}) => ({
  results,
});

const mapDispatchToProps = {
  hide: hideArchiveRequest,
  archiveData: archiveRequests,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestArchivalDialog);
